export default __webpack_public_path__ + "static/media/processor.0f7a8ca6.svg";